import React from 'react'

const TinyEditor = () => {
  return (
    <div>TinyEditor</div>
  )
}

export default TinyEditor